<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <span>
      {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.DESCRIPTION' | translate }}
    </span>
  </mat-card-content>
  <mat-card-actions align="end">
    <button
      (click)="pushToLive()"
      [disabled]="disabledButton"
      class="action-button"
      color="accent"
      mat-stroked-button
      type="button"
    >
      {{ 'PAGES.STAGING.PUSH_PRODUCTION_MODAL.BUTTONS.PUSH_TO_LIVE_SITE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
